const br_table = 1100;

export { br_table };